import React, { useEffect, useMemo, useState,useCallback } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonDataTable from '../../../components/CommonDataTable';

import HistoryIcon from '@mui/icons-material/History';

import { getCustomerListAPI } from '../../../services/customer/customer';
const rawColumns = [
    { field: 'custId', headerName: 'Customer ID', width: 180 },
    { field: 'custName', headerName: 'Name', width: 130 },
    { field: 'phone', headerName: 'Phone', width: 140 },
    { field: 'email', headerName: 'Email', width: 120 },
    { field: 'channel', headerName: 'Channel', width: 130 },
    {
        field: 'orderHistory',
        headerName: 'Order History',
        width: 120,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <IconButton
                    size="small"
                    onClick={() => handleOrderHistoryClick(params.row)}
                    aria-label="view order history"
                >
                    <HistoryIcon fontSize="small" />
                </IconButton>
            </div>
        ),
    },
    { field: 'address', headerName: 'Address', width: 180 },
    { field: 'pinCode', headerName: 'PinCode', width: 180 },
    { field: 'createdBy', headerName: 'Created By', width: 180 },
    { field: 'updatedBy', headerName: 'Updated By', width: 180 },
];


const handleOrderHistoryClick = (data) => {

}

export default function CustomerMgtList({ onCreateClick, refreshKey, onView, onEdit }) {
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [tableRows, setTableRows] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);


    const loadList = useCallback(async (page, pageSize) => {
        try {
            const customer = await getCustomerListAPI(page, pageSize);
            
            if (customer?.data.length) {
                const formattedcatons = customer?.data.map(field => ({
                    custId: field.custId,
                    custName: field.custName,
                    phone: field.phone,
                    email: field.email,
                    channel: field.channel,
                    address: field.defaultAddress.address1,
                    pinCode: field.defaultAddress.pinCode,
                    createdBy: field.createdBy,
                    updatedBy: field.updatedBy,
                    __original: field,
                    id: field._id
                }));

                setTableRows(formattedcatons);
                setTotalCount(customer?.pagination.totalRecords);
            }

            else {
                setTableRows([]);
                setTotalCount(0);
            }
        } catch (err) {
            console.error(err);
        }
    }, []);


    useEffect(() => {
        loadList(page, pageSize);
    }, [refreshKey, page, pageSize, loadList]);

    // ----------------- Menu handling -----------------
    const handleOpenMenu = (e, row) => {
        e.stopPropagation();
        setMenuAnchorEl(e.currentTarget);
        setMenuRow(row);
    };
    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    const actionColumn = {
        field: "__actions",
        headerName: "",
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
            <IconButton
                size="small"
                onClick={(e) => handleOpenMenu(e, params.row)}
                aria-label="row actions"
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
        ),
    };

    const allPossibleColumns = useMemo(() => [actionColumn, ...rawColumns], []);
    const initialVisible = useMemo(
        () => allPossibleColumns.map((c) => c.field),
        [allPossibleColumns]
    );

    return (
        <>
            <CommonDataTable
                allPossibleColumns={allPossibleColumns}
                initialVisible={initialVisible}
                initialRows={tableRows}
                height={520}
                rowsPerPageOptions={[10, 25, 50, 100]}
                exportImportPath="InventoryLedger"
                forItems
                showCreateButton={true}
                createButtonText="Create New"
                createButtonIcon="bi-plus-lg"
                onCreateClick={onCreateClick}
                createButtonVariant="contained"
                createButtonColor="primary"
                page={page}
                pageSize={pageSize}
                rowCount={totalCount}
                onPageChange={(newPage) => setPage(newPage)}
                onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0);
                }}
                onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {

                    console.log("ASN ....................... received onDataRefresh:", { filters, page: p, pageSize: ps });

                }}
            />

            <Menu open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
                <MenuItem onClick={() => onView(menuRow.__original)}>
                    <i className="bi bi-eye me-2" /> View
                </MenuItem>
                <MenuItem onClick={() => onEdit(menuRow.__original)}>
                    <i className="bi bi-pencil me-2" /> Edit
                </MenuItem>
            </Menu>
        </>
    );
}
